import React, { useContext } from "react";
import AppContext from "../../AppContext";
import { formatNumber } from "../../helpers/common.helper";
import { endOfDay, format } from "date-fns";
import { useNavigate } from "react-router-dom";
import * as Tooltip from "react-tooltip";

const assetsUri = import.meta.env.ASSETS_URI;

const TenderingCard = ({ data }) => {
  const { designStyles } = useContext(AppContext);
  const navigate = useNavigate();

  const _getStatus = () => {
    let _style = {
      label: "Announcement",
      color: "rgb(255, 255, 255)",
      background: "rgb(0, 152, 255)",
    };

    const _isOpen =
      new Date() > new Date(data.period.start) &&
      new Date() < endOfDay(new Date(data.period.end));

    if (data.status === 1 && _isOpen) {
      _style = {
        label: "Open",
        color: "#fff",
        background: "#14D886",
      };
    }

    if (data.status === 2) {
      _style = {
        label: "Tendering",
        color: "#A66A01",
        background: "#FFDB4F",
      };
    }

    return (
      <div
        className="tendering-card__status"
        style={{ color: _style.color, background: _style.background }}
      >
        {_style.label}
      </div>
    );
  };

  return (
    <div
      className="tendering-card"
      onClick={() => navigate(`/tenderings/${data._id}`)}
    >
      <img
        className="tendering-card__cover"
        src={`${assetsUri}/${
          data.images.cover.cropped ?? data.images.cover.original
        }`}
      />
      <div className="tendering-card__header">
        <span className="tendering-card__header__name">{data.name}</span>
        <span>{data.location}</span>
      </div>
      <div className="tendering-card__styles">
        {data.styles.map((style) => {
          const _designStyle = designStyles.styles.find(
            (s) => style === s.value
          );

          return (
            <div className="tendering-card__styles__tag" key={style.value}>
              {_designStyle.name}
            </div>
          );
        })}
      </div>
      <div className="tendering-card__detail">
        <div className="tendering-card__detail__info">
          <span>
            {data.area.size} {data.area.unit}
          </span>
          <span>
            {designStyles.works.find((w) => w.value === data.work)?.name}
          </span>
          <span>
            {designStyles.spaces.find((s) => s.value === data.space)?.name}
          </span>
          <span>{formatNumber(data.budget, "THB")}</span>
          <span>
            Open {format(new Date(data.period.start), "dd MMMM yyyy")}
          </span>
        </div>
        <img
          className="tendering-card__detail__owner"
          src={`${assetsUri}/${data.createdBy.avatar}`}
          width={48}
          height={48}
          onClick={(e) => {
            e.stopPropagation();

            if (data.createdBy.isCompany) {
              navigate(`/companies/${data.createdBy.uri}`);
              return;
            }

            navigate(`/${data.createdBy.uri}`);
          }}
          data-tooltip-id="tendering-owner"
          data-tooltip-content={data.createdBy.name}
        />
      </div>
      <div className="tendering-card__brief">
        <div className="tendering-card__category">
          {data.category === 1 ? "Design" : "Construction"}
        </div>
        {_getStatus()}
      </div>
      <Tooltip.Tooltip id="tendering-owner" />
    </div>
  );
};

TenderingCard.propTypes = {};

export default TenderingCard;
